// extracted by css-extract-rspack-plugin
export default {"login":"JoinTheLounge-module__login--FbjvV"};